
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-arrow_forward",
  "use": "icon-material-arrow_forward-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-arrow_forward\"><path d=\"M676.2-445.93H154.02v-68.14H676.2L432.02-758.24 480-806.22 806.22-480 480-154.02l-47.98-47.74z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-arrow_forward"/>
                </svg>
            );
        };

        Icon.id = "icon-material-arrow_forward";

        export default Icon;
    